import { gql } from '@apollo/client'

export default gql(`
    mutation updatePlayerMedia( $team: String $player: String $tournamentCalendar: String $awayImage: ID $homeImage: ID $shirtNumber: String) {
        updatePlayerTeamTournament(
            input: {
                player: $player
                team: $team
                tournamentCalendar: $tournamentCalendar
                awayImage: $awayImage
                homeImage: $homeImage
                shirtNumber: $shirtNumber
            }
        ) {
            id
            shirtNumber
            awayImage{
                id
                type
                fileName
                createdAt
                updatedAt
                type
                name
                fileSize
                isArchived
                duration
                thumbnails
                tags{
                    name
                    key
                    type
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2          
                }
                aspectRatio {
                    title
                    aspectRatio
                    ratio
                    resolutions {
                        key
                        width
                        height
                        url
                    }
                }
                streams{
                    id
                }
                vodStatus{
                    id
                }
            }
            homeImage{
                id
                type
                fileName
                createdAt
                updatedAt
                type
                name
                fileSize
                isArchived
                duration
                thumbnails
                tags{
                    name
                    key
                    type
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2          
                }
                aspectRatio {
                    title
                    aspectRatio
                    ratio
                    resolutions {
                        key
                        width
                        height
                        url
                    }
                }
                streams{
                    id
                }
                vodStatus{
                    id
                }
            }
        }
    }`
)
